@if (activeFilters().length; as filtersNumber) {
  <chr-badge *transloco="let t"
             [label]="t('COMMON.COLLECTIONS.FILTERING.APPLIED_FILTERS_NUMBER_BADGE', { filtersNumber })"
             palette="neutral"
             variant="secondary" />
}
